import { api, store } from '@spartalabs/pdc-core';
import { getFleetGroupPath } from 'utils/fleetGroupPath';
import { mapModelTableApiResponse } from 'utils/mapModelTableData';
import { mapVehicleApiResponse } from 'utils/mapVehicleTableData';

type ModelTableQueryParams = {
  term?: string;
  quantity?: number;
  page?: number;
  sorting?: { column?: number; direction?: string };
};

type VehicleTableQueryParams = {
  quantity?: number;
  page?: number;
  startDate?: string;
  plate?: string;
  chassi?: string;
  renavam?: string;
};

const getVehicleRequestParams = (params: VehicleTableQueryParams) => {
  const user = store.getState().authSlicer.user;

  return {
    grupo_Id: user.currentGroupId,
    gestor_id: user.managerId,
    data_entrega_cliente: params.startDate,
    placa: params.plate,
    chassi: params.chassi,
    renavam: params.renavam,
    limit: params.quantity || 5,
    page: params.page || 1,
  };
};

/**
 * Ensures fleet report/vehicle responses map numeroSerie -> serialNumber using
 * the raw Checklist API payload, independent of pdc-core version.
 */
api.injectEndpoints({
  overrideExisting: true,
  endpoints: builder => ({
    getModelTableData: builder.query({
      query: (params: ModelTableQueryParams) => ({
        method: 'get',
        url: `api/Frota/Modelos/${getFleetGroupPath()}`,
        params: {
          busca: params.term || null,
          quantidade: params.quantity || 5,
          pagina: params.page || 1,
          colunaOrdenacao: params.sorting?.column,
          direcaoOrdenacao: params.sorting?.direction,
        },
      }),
      transformResponse: (response: unknown) =>
        mapModelTableApiResponse(
          response as Parameters<typeof mapModelTableApiResponse>[0],
        ),
    }),
    getVehiclesTableData: builder.query({
      query: (params: VehicleTableQueryParams) => ({
        method: 'get',
        url: '/api/frota/veiculos',
        params: getVehicleRequestParams(params),
      }),
      transformResponse: (response: unknown) =>
        mapVehicleApiResponse(
          response as Parameters<typeof mapVehicleApiResponse>[0],
        ),
    }),
  }),
});
